import React, {ReactElement} from 'react';

type SuccessToastProps = {
  title: string;
  description: string;
};

const ErrorToast: React.FC<SuccessToastProps> = ({
  title,
  description,
}: //body,
SuccessToastProps): ReactElement => {
  return (
    <div>
      <div
        className="font-bold  px-6 pt-4 pb-2 bg-opacity-10 rounded-t-xl flex items-center"
        style={{backgroundColor: 'rgba(228, 0, 43, 0.05)'}}>
        <div>
          <svg viewBox="0 0 51.976 51.976" width="16" height="16">
            <path
              d="M44.373 7.603c-10.137-10.137-26.632-10.138-36.77 0-10.138 10.138-10.137 26.632 0 36.77s26.632 10.138 36.77 0c10.137-10.138 10.137-26.633 0-36.77zm-8.132 28.638a2 2 0 0 1-2.828 0l-7.425-7.425-7.778 7.778a2 2 0 1 1-2.828-2.828l7.778-7.778-7.425-7.425a2 2 0 1 1 2.828-2.828l7.425 7.425 7.071-7.071a2 2 0 1 1 2.828 2.828l-7.071 7.071 7.425 7.425a2 2 0 0 1 0 2.828z"
              fill="#D80027"></path>
          </svg>
        </div>
        <div className="ml-2 font-roboto font-bold">{title}</div>
      </div>
      <div className="bg-opacity-10 rounded-b-xl pt-2 pb-4 px-4">
        {description}
      </div>
    </div>
  );
};

export default ErrorToast;
